module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('smallBar', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4 text-center",
    on: {
      "click": function($event) {
        _vm.uploadLogoModal = true
      }
    }
  }, [_c('div', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.uploadAvatarModal = true
      }
    }
  }, [(_vm.company.logo == null) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../../assets/img/logo1.png"),
      "alt": "logo",
      "height": "60"
    }
  }) : _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.company.logo
    }
  }), _vm._v(" "), _c('small', [_vm._v("點擊更換公司LOGO")]), _vm._v(" "), _c('br'), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("公司名稱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.name),
      expression: "company.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("公司統編")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.number),
      expression: "company.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company.number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("公司地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.address),
      expression: "company.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.updateCompany()
      }
    }
  }, [_vm._v("儲存")])])])])])])])])])])])])])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  }), _vm._v(" "), (_vm.uploadLogoModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.uploadLogoModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.uploadLogoModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_vm._v("\n              上傳新的LOGO\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.uploadLogoModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('dropzone', {
    attrs: {
      "id": "myVueDropzone",
      "url": _vm.axios.defaults.baseURL + '/settings/update_company',
      "headers": _vm.auth_token,
      "maxFileSizeInMB": 12
    },
    on: {
      "vdropzone-success": _vm.vsuccess
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.uploadLogoModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deal_sidebar block-header clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("公司資訊")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab6fbdfc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/Company.vue
// module id = 707
// module chunks = 4